export default "__VITE_ASSET__DZxYVUcg__"